import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaMapNode } from './TypedNode'
import { SchemaMapModel } from './ViewModel'

export const SchemaMapPlugin = createSchemaPlugin(
  'Schema.Map',
  SchemaMapModel,
  SchemaMapNode
)
